import { useEffect, useState } from "react";
import { fetchArticles, fetchCategories } from "../lib/api";
import ArticleCard from "../components/ArticleCard";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Reviews() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    fetchArticles({ type: "review" }).then(setItems).catch(() => {});
    fetchCategories().then(setCategories).catch(() => {});
  }, []);

  const filtered = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="reviews-page">
      <Breadcrumbs items={[{ label: "Reviews" }]} />
      <header className="mb-12 max-w-3xl">
        <p className="eyebrow mb-3">Reviews</p>
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-neutral-900 tracking-tight leading-[1.05] mb-5">
          In-depth software reviews.
        </h1>
        <p className="text-lg text-neutral-600 leading-relaxed">
          Each review walks through what a product does, who it fits, where it
          shines, and where it falls short — organized to help you make a call
          quickly.
        </p>
      </header>

      <div className="flex flex-wrap items-center gap-2 mb-10" data-testid="reviews-filter">
        {["All", ...categories.map((c) => c.name)].map((name) => (
          <button
            key={name}
            type="button"
            onClick={() => setActive(name)}
            data-testid={`reviews-filter-${name.toLowerCase().replace(/[^\w]+/g, "-")}`}
            className={`px-4 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              active === name
                ? "bg-indigo-800 border-indigo-800 text-surface"
                : "bg-surface border-neutral-300 text-neutral-700 hover:border-indigo-800 hover:text-indigo-800"
            }`}
          >
            {name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {filtered.map((a, i) => (
          <ArticleCard key={a.id} article={a} basePath="/reviews" index={i} />
        ))}
      </div>
      {!filtered.length && (
        <p className="text-neutral-500 text-sm">No reviews in this category yet.</p>
      )}
    </div>
  );
}
